module.exports = __webpack_public_path__ + "img/skiing1.9897e2ab.jpg";